export default __webpack_public_path__ + "static/Libro.fm_logo.svg-224e3842da035b7801f61871fa0ac8c3.png";